import { PERMISSIONS, USERS_PERMISSIONS } from "../utils/permissionConstants";

export const navigationItems = [
  {
    path: "/Dashboard",
    label: "Dashboard",
    icon: "dashboard",
    permission: PERMISSIONS.DASHBOARD.VIEW, // Dashboard view permission
  },
  {
    path: "/Request",
    label: "Requests Ride",
    icon: "request",
    permission: PERMISSIONS.DASHBOARD.VIEW, // No rides permission group in /roles/groups
  },
  {
    path: "/Request_city",
    label: "Requests Ride City",
    icon: "request-city",
    permission: PERMISSIONS.DASHBOARD.VIEW, // dashboard
  },
  {
    path: "/Payment",
    label: "Payments",
    icon: "payment",
    permission: PERMISSIONS.DASHBOARD.VIEW, // No payments permission group in /roles/groups
  },
  {
    path: "/Transactions",
    label: "Transactions",
    icon: "transactions",
    permission: PERMISSIONS.TRANSACTIONS.VIEW, // Transactions view permission
  },
  {
    path: "/Driver",
    label: "Drivers",
    icon: "driver",
    permission: USERS_PERMISSIONS.VIEW, // Drivers view permission per instruction
  },
  {
    path: "/User",
    label: "Users",
    icon: "users",
    permission: USERS_PERMISSIONS.VIEW, // Users view permission per instruction
  },
  {
    path: "/Hours",
    label: "Rush Hours",
    icon: "hours",
    permission: PERMISSIONS.RUSH_HOURS.VIEW, // Rush hours view permission
  },
  {
    path: "/Promo",
    label: "Promo codes",
    icon: "promo",
    permission: PERMISSIONS.PROMO_CODES.VIEW, // Promo codes view permission
  },
  {
    path: "/Adv",
    label: "Advertisements",
    icon: "adv",
    permission: PERMISSIONS.ADVERTISEMENTS.VIEW, // Advertisements view permission
  },
  {
    path: "/CityRidesPrice",
    label: "City Rides Price",
    icon: "city-price",
    permission: PERMISSIONS.PRICING.VIEW, // Pricing view permission
  },
  {
    path: "/RidePricing",
    label: "Ride Pricing",
    icon: "pricing",
    permission: PERMISSIONS.PRICING.VIEW, // Pricing view permission
  },
  {
    path: "/Roles",
    label: "Roles & Permissions",
    icon: "roles",
    permission: PERMISSIONS.ROLES.VIEW, // Roles view permission
  },
  {
    path: "/SubAdmins",
    label: "Sub Admins",
    icon: "sub-admins",
    permission: PERMISSIONS.SUB_ADMINS.VIEW, // Sub admins view permission
  },
  {
    path: "/Setting",
    label: "Setting",
    icon: "settings",
    permission: PERMISSIONS.SETTINGS.VIEW, // Settings view permission
  },
];
